<template>
  <v-card>
    <v-card-title class="pr-2" :style=" { backgroundColor: colors.primary.hex }">
      <h2 style="color:white">3CX-aansluiting toevoegen</h2>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeAddCompDialog()">
        <v-icon dark color="white">close</v-icon>
      </v-btn>
    </v-card-title>

    <v-alert
      class="ma-0 pa-2"
      v-if="feedback"
      :value="true"
      type="warning"
    >
    {{ feedback }} 
    </v-alert>

    <v-divider></v-divider>

    <v-card-text>
      <v-form ref="AddCompForm" v-model="valid" lazy-validation>
        <v-text-field
          class="pt-4"
          label="Naam 3CX-aansluiting"
          v-model="newComp.name"
          :rules="requiredRules"
          prepend-inner-icon="account_box"
          :color="colors.primary.hex"
          background-color="background"       
          hide-details
          required
          outlined
        ></v-text-field>
        <v-text-field
          class="pt-4"
          label="Email"
          v-model="newComp.email"
          :rules="emailRules"
          prepend-inner-icon="email"
          :color="colors.primary.hex"
          background-color="background"       
          hide-details
          required
          outlined
        ></v-text-field>
         <v-text-field
          class="pt-4"
          label="Website url"
          v-model="newComp.url"
          :rules="requiredRules"
          prepend-inner-icon="web"
          :color="colors.primary.hex"
          background-color="background"       
          hide-details
          required
          outlined
        ></v-text-field>
        <v-select
          class="pt-4"
          v-model="newComp.type"
          :items="companyTypes"
          label="Type aansluiting"
          item-text="name"
          item-value="id"
          prepend-inner-icon="business"
          :rules="requiredRules"
          :color="colors.primary.hex"
          :item-color="colors.primary.hex"
          background-color="background"       
          hide-details
          required
          outlined
        ></v-select>

        <v-select
          v-if="softwareTypesFiltered"
          class="pt-4"
          v-model="newComp.software"
          :items="softwareTypesFiltered"
          label="Selecteer gebruikte software"
          item-text="name"
          item-value="id"
          prepend-inner-icon="mouse"
          :rules="requiredRules"
          :color="colors.primary.hex"
          :item-color="colors.primary.hex"
          background-color="background"       
          hide-details
          required
          outlined
        ></v-select>

        <v-select
          class="pt-4"
          v-model="newComp.packages"
          :items="packages"
          multiple
          label="Selecteer pakketten"
          item-text="name"
          chips
          item-value="id"
          prepend-inner-icon="lock"
          :rules="requiredRules"
          :color="colors.primary.hex"
          :item-color="colors.primary.hex"
          background-color="background"       
          hide-details
          required
          outlined
        ></v-select>
         
        
        <div class="color-box-wrapper clear pt-4">
          <div class="color-boxes-icon">
            <v-icon>palette</v-icon>
          </div>
          <div class="color-boxes clear">
            <p class="ma-0">Selecteer primaire en secondaire kleur</p>
            <div class="color-box" v-bind:style="{ backgroundColor: colors.primary.hex }" @click="primaryColorDialog = true"></div>
            <div class="color-box" v-bind:style="{ backgroundColor: colors.secondary.hex}" @click="secondaryColorDialog = true"></div>
          </div>
        </div>

        <!-- <div class="upload-image-wrapper clear pt-4">
          <div class="upload-image-icon">
            <v-icon>image</v-icon>
          </div>
          <div class="upload-image">
            <p class="ma-0">Upload bedrijfslogo</p>
            <div v-if="filename" class="logo-upload-preview">
              <img :src="newComp.logoUrl">
              <div v-if="uploading == true" class="upload-bar">
                <p class="ma-0">{{ uploadProgress }} %</p>
                <div class="upload-bar-inner" v-bind:style="{ backgroundColor: colors.primary.hex, width: uploadProgress  + '%'  }"></div>
              </div>
            </div>
            <v-btn raised :color="colors.primary.hex" dark @click="onFileSelect">Kies afbeelding</v-btn>
            <input
              type="file"
              style="display: none;"
              ref="fileInput"
              accept="image/*"
              @change="onFilePicked">
          </div>
        </div> -->
        <div class="form-active-switch">
          <v-switch
            :color="colors.primary.hex"
            label="Actief"
            v-model="newComp.active"
          ></v-switch>
        </div>

      </v-form>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
            <v-btn
              outlined
              depressed
              :color="colors.secondary.hex"
              @click="closeAddCompDialog()"
              >
              Annuleren
            </v-btn>
          </v-flex>
          <v-flex xs12 md6 class="text-right">
            <v-btn
              dark
              rounded
              :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
              :color="colors.secondary.hex"
              @click="addCompany()"
              >
              Aansluiting toevoegen
              <v-icon right dark>chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>
      
    <v-dialog width="225px" v-model="primaryColorDialog">
      <chrome-picker v-model="colors.primary"></chrome-picker>
    </v-dialog>

    <v-dialog width="225px" v-model="secondaryColorDialog">
      <chrome-picker v-model="colors.secondary"></chrome-picker>
    </v-dialog>
      
  </v-card>
</template>


<script>
import db from "../../firebase/init";
import firebase from "firebase/app";;
import { Chrome } from "vue-color";
import platform from 'platform'; 

export default {
  name: "add-comp-form",
  components: {
    "chrome-picker": Chrome
  },
  props: {
    softwareTypes: Object,
    companyTypes: Array, 
    packages: Array
  },
  data() {
    return {
      valid: false,
      newComp: {
        logoUrl: null,
        active: true,
        languages: ["nl"],
        type: "generalPractice",
        packages: [],
        software: null,
        apiItems: {}
      },
      requiredRules: [v => !!v || "Dit veld is verplicht"],
      filename: null,
      image: null,
      colors: {
        primary: {
          a: 1,
          hex: "#1867c0",
          hex8: "#1867c0FF",
          rgba: {
            a: 1,
            r: 24,
            g: 103,
            b: 192
          },
          source: "rgba"
        },
        secondary: {
          a: 1,
          hex: "#454544",
          hex8: "#454544FF",
          rgba: {
            a: 1,
            r: 69,
            g: 69,
            b: 68
          },
          source: "rgba"
        }
      },
      primaryColorDialog: false,
      secondaryColorDialog: false,
      emailRules: [
        v => !!v || "E-mail is verplicht",
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || "E-mail must be valid"
      ],
      feedback: null,
      recordId: null,
      uploading: false,
      uploadProgress: null,
      file: {}
    };
  },

  methods: {
    closeAddCompDialog() {
      this.$emit("newCompDialogChange", false);
      this.feedback = null;
      this.colors =  {
        primary: {
          a: 1,
          hex: "#1867c0",
          hex8: "#1867c0FF",
          rgba: {
            a: 1,
            r: 24,
            g: 103,
            b: 192
          },
          source: "rgba"
        },
        secondary: {
          a: 1,
          hex: "#454544",
          hex8: "#454544FF",
          rgba: {
            a: 1,
            r: 69,
            g: 69,
            b: 68
          },
          source: "rgba"
        }
      }
    },

    onFileSelect() {
      this.$refs.fileInput.click();
    },

    onFilePicked(event) {
      const files = event.target.files;
      this.file = files[0];
      let filename = files[0].name;
      this.filename = filename;
      console.log("files: " + filename);
      if (filename.lastIndexOf(".") <= 0) {
        this.feedback = "Voeg een geldig bestand toe.";
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.newComp.logoUrl = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.image = files[0];
      this.feedback = null;
    },

    addCompany() {
      if (this.$refs.AddCompForm.validate()) {
        let compName = this.newComp.name;
        let compNameLower = compName.toLowerCase();
        let compNameLowerNoSpecial = compNameLower.replace(/[!@#$%^&*+()"';:.,]+/g, "");
        this.newComp.id = compNameLowerNoSpecial.replace(/\s+/g, "");

        db.collection("companies")
          .doc(this.newComp.id)
          .set({
            // Basic Company Settings
            active: this.newComp.active,
            name: this.newComp.name,
            email: this.newComp.email,
            url: this.newComp.url,
            logoUrl: null,
            colors: this.colors,
            deleted: {
              deleted: false
            },
            packages: this.newComp.packages,
            type: this.newComp.type,
            languages: this.newComp.languages,
            software: this.newComp.software,
            apiItems: this.newComp.apiItems,
            created: new Date()
          })
          .then(async () => {
            if (this.filename) {
              await this.uploadCompanyLogo();
            }
          })
          .then(() => {
            db.collection("log").add({
              time: new Date(),
              logType: "info",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              software: String(platform.os),
              browser: platform.name + ' ' + platform.version, 
              action: "Aansluiting toegevoegd: " + this.newComp.name,
              extra:
                "<b>Active</b>: " +
                this.newComp.active +
                "<br>" +
                "<b>Naam</b>: " +
                this.newComp.name +
                "<br>" +
                "<b>E-mail</b>: " +
                this.newComp.email +
                "<br>" +
                "<b>Url</b>: " +
                this.newComp.url
            });
          })
          .then(() => {
            this.$emit("updateData");
            this.closeAddCompDialog();
            console.log("Company succesfully added");
            
          })
          .catch(error => {
            console.error("Error adding Company: ", error);
            db.collection("log").add({
              time: new Date(),
              logType: "error",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              action: "Error adding Company: " + this.activeCompName,
              software: String(platform.os),
              browser: platform.name + ' ' + platform.version, 
              extra: JSON.stringify(error)
            });
          });
      } else {
        this.feedback = "Vul alle velden in om een aansluiting toe te voegen.";
      }
    },

    uploadCompanyLogo() {
      return new Promise((resolve, reject) => {
        console.log("start storen");
        const file = this.file;
        const filename = this.filename;
        const ext = filename.slice(filename.lastIndexOf("."));
        const fileUrl = this.newComp.id + "/" + "logo/" + this.newComp.id + "-logo" + ext;
        this.uploading = true;
        let uploadTask = firebase
          .storage()
          .ref(fileUrl)
          .put(file);

        uploadTask.on(
          "state_changed",
          taskSnapshot => {
            var progress = Math.ceil((taskSnapshot.bytesTransferred / taskSnapshot.totalBytes) * 100);
            this.uploadProgress = progress;
          },
          error => {
            console.error(error)
            reject();
          },
          () => {
            console.log("The upload is compleet");
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then(url => {
                db.collection("companies")
                  .doc(this.newComp.id)
                  .update({
                    logoUrl: url
                  })
                  .then(() => {
                    resolve();
                    this.uploading = false;
                    this.uploadProgress = null;
                  })
                  .catch(error => {
                    reject();
                    this.uploading = false;
                    this.uploadProgress = null;
                    console.error(error)
                  });
              })
              .catch(error => {
                reject();
                this.uploading = false;
                this.uploadProgress = null;
                console.error(error)
              });
          }
        );
      });
    }
  },
  computed: {

    softwareTypesFiltered(){
      if(this.softwareTypes){
        if(this.softwareTypes[this.newComp.type] && this.softwareTypes[this.newComp.type].length > 0){
          return this.softwareTypes[this.newComp.type]
        }
        else {
          return null;
        }
      }
      else {
        return null;
      } 
    },

    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    }
  }
};
</script>
